import { render, staticRenderFns } from "./GraphStatistics.vue?vue&type=template&id=2c0d096d"
import script from "./GraphStatistics.vue?vue&type=script&lang=ts"
export * from "./GraphStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports